<script setup lang="ts">
import { createInput } from '@formkit/vue'
import PersonCreator from './CreateInputBase/PersonCreator.vue'

const personCreator = createInput(PersonCreator, { props: ['disabled', 'hint', 'multiple', 'translationKey'] })
</script>

<template>
  <FormKit :type="personCreator" />
</template>
